import config from "./config";
import { SORT_MAP } from "../constants";

const FILTER_ID = {
  cityName: "cityName",
  continents: "continents",
  travelStyle: "travelStyle",
  travelPref: "travelPref",
  tripType: "tripType",
  lodgingPref: "lodgingPref",
  order: "order",
  page: "page",
  overallScore: "overallScore",
  thingsToDoScore: "thingsToDoScore",
  travelingWhileBlackScore: "travelingWhileBlackScore",
  adventureScore: "adventureScore",
  historyScore: "historyScore",
  relaxationScore: "relaxationScore",
  localFoodScore: "localFoodScore",
  nightlifeScore: "nightlifeScore",
  romanceScore: "romanceScore",
  affordabilityScore: "affordabilityScore",
  cityCharacteristics: "cityCharacteristics",
  subOpened: "subOpened"
};

const FILTER_PREMIUM = {
  northAmerica: false,
  southAmerica: true,
  europe: true,
  africa: true,
  asia: true,
  oceania: true,
  antarctica: true,
  travelingWhileBlackScore: false,
  adventureScore: false,
  historyScore: false,
  romanceScore: false,
  nightlifeScore: false,
  travelStyle: false,
  tripType: false,
  travelPref: false,
  lodgingPref: false
};

const FILTER_CHECKBOXES = {
  [FILTER_ID.continents]: {
    northAmerica: "North America",
    southAmerica: "South America",
    europe: "Europe",
    africa: "Africa",
    asia: "Asia",
    oceania: "Oceania",
    antarctica: "Antarctica"
  },
  [FILTER_ID.travelStyle]: {
    adventureSeeker: "Adventure Seeker",
    partyGoer: "Party Goer",
    restRelaxation: "Rest Relaxation",
    foodie: "Foodie",
    historyBuff: "History Buff"
  },
  [FILTER_ID.tripType]: {
    solo: "Solo",
    groups: "Groups",
    bae: "Trips with Bae",
    girl: "Girl-Trips",
    brio: "Bro-Trips"
  },
  [FILTER_ID.travelPref]: {
    luxury: "Luxury-Traveler",
    luxuryBudget: "Mix of Luxury/Budget",
    budget: "Budget-Traveler"
  },
  [FILTER_ID.lodgingPref]: {
    booking: "AirBNB/VRBO/etc.",
    hotels: "Hotels",
    hostels: "Hostels"
  }
};

const SECTION_RANGE = {
  [FILTER_ID.travelingWhileBlackScore]: "Traveling While Black",
  [FILTER_ID.overallScore]: "Overall City Score",
  [FILTER_ID.thingsToDoScore]: "Things To do"
};

const SECTION_RANGE_MORE = {
  [FILTER_ID.adventureScore]: "Adventure",
  [FILTER_ID.historyScore]: "History",
  [FILTER_ID.relaxationScore]: "Relaxation",
  [FILTER_ID.localFoodScore]: "Local Food",
  [FILTER_ID.romanceScore]: "Romance",
  [FILTER_ID.nightlifeScore]: "Nightlife",
  [FILTER_ID.affordabilityScore]: "Affordability"
};

const SECTION_CHECKBOX_TOP = {
  [FILTER_ID.continents]: "Parts Of The World"
};

const SECTION_CHECKBOX_OTHER = {
  [FILTER_ID.travelStyle]: "Travel Style",
  [FILTER_ID.tripType]: "Preferred Trip Type",
  [FILTER_ID.travelPref]: "Travel Preference",
  [FILTER_ID.lodgingPref]: "Preferred Lodging"
};

const FILTER_RANGES = { ...SECTION_RANGE, ...SECTION_RANGE_MORE };

export const FILTER = {
  id: FILTER_ID,
  premium: FILTER_PREMIUM,
  section: {
    first: SECTION_CHECKBOX_TOP,
    second: SECTION_RANGE,
    secondMore: SECTION_RANGE_MORE,
    third: SECTION_CHECKBOX_OTHER
  },
  checkbox: FILTER_CHECKBOXES,
  range: FILTER_RANGES
};

export function hasAccess(id) {
  return config.premiumUser || !FILTER_PREMIUM[id];
}

export function getQueryArray(el) {
  if (!el) {
    return [];
  }
  if (Array.isArray(el)) {
    return el;
  }
  if (typeof el === "string") {
    return [el];
  }
}

export function getRangeDefaultValue(el) {
  return [el ? +el[0] : 0, el ? +el[1] : 5];
}

export function getAllFiltersQuantity(query) {
  const filters = Object.keys(query);
  let filtersQuantity = filters.length;
  if (filtersQuantity === 0) {
    return null;
  }
  if (filters.includes(FILTER_ID.page)) {
    filtersQuantity -= 1;
  }
  if (filters.includes(FILTER_ID.continents)) {
    filtersQuantity -= 1;
  }
  if (filters.includes(FILTER_ID.subOpened)) {
    filtersQuantity -= 1;
  }
  return filtersQuantity <= 0 ? null : `(${filtersQuantity})`;
}

export function generateFiltersInfo(query) {
  const filters = Object.entries(query);
  let filtersInfo = {};
  if (filters.length === 0) {
    return filtersInfo;
  }
  let countCityCharacteristics = 0;
  const secondaryList = Object.keys(FILTER_RANGES);

  filters.forEach(([id, val]) => {
    let descr = "";
    if (typeof val === "string") {
      descr = `(1)`;
    }
    if (Array.isArray(val)) {
      if (
        val.length === 2 &&
        typeof +val[0] === "number" &&
        typeof +val[1] === "number" &&
        secondaryList.includes(id)
      ) {
        countCityCharacteristics += 1;
      } else {
        descr = `(${val.length})`;
      }
    }
    filtersInfo = {
      ...filtersInfo,
      [id]: descr
    };
    if (countCityCharacteristics > 0) {
      filtersInfo = {
        ...filtersInfo,
        cityCharacteristics: `(${countCityCharacteristics})`
      };
    }
  });
  return filtersInfo;
}

export function getRating(country) {
  const { average_rating } = country;

  return +average_rating.average_rating;
}

export function getDefaultQuery(q) {
  let query = { ...q };

  Object.keys(FILTER_RANGES).forEach(id => {
    if (hasAccess(id) && !query[id]) {
      query = {
        ...query,
        [id]: config.defaultRange
      };
    }
  });

  if (!query[FILTER_ID.order]) {
    const selectedSortingKey =
      Object.keys(SORT_MAP).find(key => SORT_MAP[key].selected) || "reviews";
    const selectedSorting = SORT_MAP[selectedSortingKey];
    query = {
      ...query,
      [FILTER_ID.order]: [selectedSorting.id, selectedSorting.orderBy]
    };
  }

  if (!query[FILTER_ID.continents]) {
    query = {
      ...query,
      [FILTER_ID.continents]: config.premiumUser
        ? Object.keys(FILTER_CHECKBOXES[FILTER_ID.continents])
        : ["northAmerica"]
    };
  }
  return query;
}
